module.exports = __webpack_public_path__ + "img/caiwu.addbead4.svg";